"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _dhanalytics = _interopRequireDefault(require("@adsk/dh-analytics/dist/bundles/dhanalytics.lite"));
var _haAdpDotcomLoggerUtil = require("@adsk/ha-adp-dotcom-logger-util");
var _useScript = _interopRequireDefault(require("../../utils/hooks/useScript"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable no-underscore-dangle */

var GuidedTroubleshootingBody = function GuidedTroubleshootingBody(_ref) {
  var caasKey = _ref.caasKey,
    content = _ref.content,
    adpParams = _ref.adpParams,
    adpConfig = _ref.adpConfig;
  var url = 'https://help.autodesk.com/view/cxd-components/ui-x-solution-path/ui-x-solution-path.js';
  var status = (0, _useScript.default)(url);
  (0, _react.useEffect)(function () {
    if (status === 'ready') {
      if (window && window.UIXComponent && window.UIXComponent.SolutionPath) {
        window.UIXComponent.SolutionPath.init();
        window.DHAnalytics = _dhanalytics.default;
        var adpEnv = (0, _haAdpDotcomLoggerUtil.setDefaultEnvironment)();
        // Init async method for CSP ADP capture as that's what it comes with.
        window._dhaq = window._dhaq || [];
        window._dhaq.push({
          cmd: 'init',
          config: {
            appId: adpConfig[adpEnv].appId,
            env: adpEnv,
            ADPData: {
              apiKey: adpConfig[adpEnv].apiKey,
              signWith: adpConfig[adpEnv].signWith
            }
          },
          data: adpParams
        });

        // Append CDN CSS for WTIH.
        var head = document.getElementsByTagName('head')[0];
        var wtihCss = document.createElement('link');
        wtihCss.rel = 'stylesheet';
        wtihCss.type = 'text/css';
        wtihCss.href = 'https://help.autodesk.com/view/cxd-components/util-adp-sdk/dh_helpful.css';
        head.appendChild(wtihCss);
        var elem = document.getElementsByClassName('ui-x-solution-path');
        // change name of element so init, if rendered in browser, is blocked
        if (elem && elem.length > 0) {
          elem.item(0).className = 'ui-x-sp-completed';
        }
      }
    }
  }, [status, adpParams, adpConfig]);

  // Ensures correct caasKey is used for localized content.
  var adjustedContent = content.replace(/data-caaskey="(.*)"/g, "data-caaskey=\"".concat(caasKey, "\""));
  // This in theory should pass the correct env, but is currently not.
  // .replace('init()', `init({env:'${env}'})`);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "hide-version",
    style: {
      fontFamily: 'ArtifaktElement'
    }
  }, status === 'ready' ? /*#__PURE__*/_react.default.createElement("div", null, (0, _htmlReactParser.default)(adjustedContent)) : null);
};
GuidedTroubleshootingBody.propTypes = {
  /**
   * Unique CaaS ID.
   */
  caasKey: _propTypes.default.string.isRequired,
  /**
   * Caas params for ADP logging.
   */
  // eslint-disable-next-line react/forbid-prop-types
  adpParams: _propTypes.default.object.isRequired,
  /**
   * CaaS content to render.
   */
  content: _propTypes.default.node,
  adpConfig: _propTypes.default.string
};
GuidedTroubleshootingBody.defaultProps = {
  content: '',
  adpConfig: ''
};
var _default = GuidedTroubleshootingBody;
exports.default = _default;